import Api from "./Api";

const endpoint = "/werke";
export default {
    get() {
        var usedParams = {};
        return Api.fetchData(endpoint);
    },
    getMitglieder(id) {
        return Api.fetchData(endpoint + "/mitglieder/" + id);
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    put(id, data) {
        return Api.putData(endpoint + "/" + id, data);
    },
    putMitglieder(id, data) {
        return Api.putData(endpoint + "/mitglieder/" + id, data);
    },
    delete(id) {
        return Api.deleteData(endpoint + "/" + id);
    }
};
